import Modal from "~/common/components/Modal";

import classes from "./NotificationSettingsConfirmationPopup.module.less";
import { Stacker } from "~/common/components/Stacker/Stacker";
import { Button } from "~/common/components/Button/Button";
import { type ConfirmationModalProps } from "~/AddToCart/ModalSevice";
import { resolveResourceURl } from "~/utils/url/urlResolver";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface Props extends ConfirmationModalProps {}
export const NotificationSettingsConfirmationPopup = ({ onConfirm, onCancel }: Props) => {
  const { t } = useTranslation();

  const footer = (
    <Stacker gap={8} direction={"row"}>
      <Button onClick={onCancel} variant={"text"}>
        {t("cancel")}
      </Button>
      <Button onClick={onConfirm}>{t("updatePwd.confirm")}</Button>
    </Stacker>
  );

  return (
    <Modal
      onClose={onCancel}
      footerChildren={footer}
      title={t("notification-settings-popup.confirmation.title")}
      modalClassName={classNames(classes.popup)}
    >
      <section className={classes.root}>
        <img className={classes.image} src={resolveResourceURl("/images/close_notification.svg")} />
        <p className={classes.text}>{t("notification-settings-popup.confirmation.description")}</p>
      </section>
    </Modal>
  );
};
